export default __webpack_public_path__ + "static/media/bc-logo.dd25ec0c.svg";